import React from "react";
import { twClassNames } from "../helpers/twClassNames";
import Button, { ButtonProps } from "./Button";

export const SignOutButton = ({
    handleLogout,
    className,
    onClick,
    ...props
}: { handleLogout: () => void } & ButtonProps) => {
    return (
        <Button
            onClick={handleLogout}
            className={twClassNames("border-none", className)}
            type="red-ghost"
            {...props}
        >
            Sign out
            <i className="far fa-fw fa-sign-out"></i>
        </Button>
    );
};
